import React from 'react';
import amcStyles from '../../styles/amcs.scss';

interface CIO {
  name: string;
  description: string;
}

interface CIOsProps {
  amcCIOs: CIO[] | null;
  expandedCIOIndex: number | null;
  toggleCIO: (index: number) => void;
  amcName: string;
}

const CIOs: React.FC<CIOsProps> = ({
  amcCIOs,
  expandedCIOIndex,
  toggleCIO,
  amcName,
}) => {
  if (!amcCIOs || !Array.isArray(amcCIOs)) {
    return <div>Loading CIOs</div>;
  }

  if (amcCIOs.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="sm:lil-mt-8">
        <h2 className={`${amcStyles['plan-title']} lil-pb-2`}>
          {amcName} CIOs
        </h2>
        <div className="lil-rounded-xl lil-bg-white lil-pb-4">
          {amcCIOs.map((cio: CIO, index: number) => {
            const isExpanded = expandedCIOIndex === index;
            return (
              <div key={index} className="lil-relative">
                <div
                  className="lil-flex lil-justify-between lil-items-center lil-py-5 lil-relative"
                  onClick={() => toggleCIO(index)}
                >
                  <span className="lil-font-medium lil-text-s-24">
                    {cio.name}
                  </span>
                  <span>
                    {isExpanded ? (
                      <img
                        src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742892758_upchevron.svg"
                        alt="Collapse"
                      />
                    ) : (
                      <img
                        src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742892858_downchevron.svg"
                        alt="Expand"
                      />
                    )}
                  </span>
                </div>
                <div className={`lil-pb-6 ${isExpanded ? '' : 'lil-hidden'}`}>
                  {cio.description.split('\n\n').map((paragraph, pIndex) => (
                    <p
                      key={pIndex}
                      className="lil-font-normal lil-text-s-18 lil-text-grey-600 lil-mb-4"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
                <div className="lil-bottom-0 lil-left-0 lil-right-0 lil-absolute lil-h-px lil-bg-grey-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CIOs;



// WEBPACK FOOTER //
// ./components/amcNew/CIOs.tsx